import graphqlClient from "../../../apollo";

class OrderStateProvider {

    findOrderState(id) {
        return graphqlClient.query({
            query: require('./gql/OrderState/findOrderState.graphql'),
            variables: {id: id}
        })
    }

    fetchOrderState() {
        return graphqlClient.query({
            query: require('./gql/OrderState/fetchOrderState.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateOrderState(pageNumber, itemsPerPage, search = null, filters = null, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/OrderState/paginateOrderState.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }


    createOrderState(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/OrderState/createOrderState.graphql'),
            variables: {input}
        })
    }

    updateOrderState(id, input) {
        return graphqlClient.mutate({
            mutation: require('./gql/OrderState/updateOrderState.graphql'),
            variables: {id, input}
        })
    }

    deleteOrderState(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/OrderState/deleteOrderState.graphql'),
            variables: {id}
        })
    }

}

export default new OrderStateProvider()


